export const featureList = {
  showTenants: "show-tenants",
  tenantDebitNowPayment: "tenant-debit-now-payment",
  tenantBankAccountDetails: "tenant-bank-account-details",
  hideTenantRequestTab: "hide-tenant-request-tab",
  showOffers: "show-offers",
  showKolmeoPlusExploreTab: "show-kolmeoplus-tenant-explore-tab",
  showKolmeoOwnerPlusExploreTab: "show-kolmeoplus-owner-explore-tab",
  showKolmeoPlusExploreService: "show-kolmeoplus-tenant-explore-service",
  showKolmeoPlusOwnerExploreService: "show-kolmeoplus-owner-explore-service",
  showKolmeoPlusExploreDiscount: "show-kolmeoplus-tenant-explore-discounts",
  showKolmeoPlusExploreArticle: "show-kolmeoplus-tenant-explore-helpful-articles",
  showKolmeoPlusHelpfulResources: "show-kolmeoplus-tenant-helpful-resources-tile",
  showKolmeoPlusHelpfulResourcesOwner: "show-kolmeoplus-owner-helpful-resources-tile",
  showKolmeoPlusTenantVacateLease: "show-kolmeoplus-tenant-vacate-lease",
  showKolmeoPlusTenantVacateLeaseTile: "show-kolmeoplus-tenant-vacate-lease-tile",
  showTenantRequestToVacateButton: "show-tenant-request-to-vacate-button",
  showKolmeoPlusOwnerExploreDiscounts: "show-kolmeoplus-owner-explore-discounts",
  showTenantInvoicesTab: "show-tenant-invoices-tab"
} as const;
